export interface PollCreationInformation {
    question: string;
    options: { option: string; optionNumber: number }[];
}

export interface Poll {
    pollGuid: string;
    status?: 'ACTIVE' | 'DONE';
    question: string;
    results?: { [key: string]: { option: string; votes: number; } }; // Option is the option name, there is no id
    options?: { option: string; optionNumber: number; }[];
    eventId?: string,
    pollInstanceGuid?: string; // Only if active
    initiatorGuid?: string;
    initiatorName?: string;
    endedOn?: number;
    startedOn?: number;
    creatorName?: string,
    creatorGuid?: string,
}

export enum PollInstanceStatus {
    ACTIVE = 'ACTIVE',
    AVAILABLE = 'AVAILABLE',
    COMPLETED = 'COMPLETED'
}
